import React from "react";
// Sections for this page
import Page from "components/pages/Page/Page";

export default function LandingPage(props) {
  return <Page type={props.type} />;
}
